import React, { useState } from 'react';
import {
    Box,
    Button,
    Grid,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Collapse
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const KOT = () => {
    const [categories, setCategories] = useState({});
    const [newCategory, setNewCategory] = useState('');
    const [expandedCategory, setExpandedCategory] = useState(null);
    const [newSubcategory, setNewSubcategory] = useState('');
    const [ setSubcategories] = useState({});

    // Category Management Handlers
    const handleAddCategory = () => {
        if (newCategory && !categories[newCategory]) {
            setCategories({
                ...categories,
                [newCategory]: []
            });
            setNewCategory('');
        }
    };

    const handleDeleteCategory = (category) => {
        const { [category]: _, ...rest } = categories;
        setCategories(rest);
        setSubcategories(prev => ({
            ...prev,
            [category]: [] // Clear subcategories for the deleted category
        }));
        if (expandedCategory === category) {
            setExpandedCategory(null); // Close the expanded category if it was deleted
        }
    };

    // Subcategory Management Handlers
    const handleAddSubcategory = () => {
        if (expandedCategory && newSubcategory) {
            setCategories(prev => ({
                ...prev,
                [expandedCategory]: [...(prev[expandedCategory] || []), newSubcategory]
            }));
            setNewSubcategory('');
        }
    };

    const handleDeleteSubcategory = (subCategory) => {
        if (expandedCategory) {
            setCategories(prev => ({
                ...prev,
                [expandedCategory]: prev[expandedCategory].filter(sub => sub !== subCategory)
            }));
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Kitchen of Order (KOT)
            </Typography>

            {/* Category Management */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6">Category Management</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="New Category"
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                        />
                        <Button variant="contained"  onClick={handleAddCategory} sx={{ mt: 2 , backgroundColor:'orange'}}>
                            Add Category
                        </Button>
                    </Grid>
                </Grid>
            </Box>

            {/* Category Table with Expandable Subcategories */}
            <Box>
                <Typography variant="h6">Categories</Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Category</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(categories).map(category => (
                                <React.Fragment key={category}>
                                    <TableRow>
                                        <TableCell>
                                            <Button onClick={() => setExpandedCategory(expandedCategory === category ? null : category)}>
                                                {expandedCategory === category ? '-' : '+'} {category}
                                            </Button>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => handleDeleteCategory(category)} color="error">
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={2} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                            <Collapse in={expandedCategory === category}>
                                                <Box sx={{ margin: 1 }}>
                                                    <Typography variant="h6">Subcategories</Typography>
                                                    <TextField
                                                        fullWidth
                                                        label="New Subcategory"
                                                        value={newSubcategory}
                                                        onChange={(e) => setNewSubcategory(e.target.value)}
                                                        sx={{ mt: 2 }}
                                                    />
                                                    <Button variant="contained" color="primary" onClick={handleAddSubcategory} sx={{ mt: 2 }}>
                                                        Add Subcategory
                                                    </Button>
                                                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                        <Table>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Subcategory</TableCell>
                                                                    <TableCell>Actions</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(categories[category] || []).map(subCategory => (
                                                                    <TableRow key={subCategory}>
                                                                        <TableCell>{subCategory}</TableCell>
                                                                        <TableCell>
                                                                            <IconButton onClick={() => handleDeleteSubcategory(subCategory)} color="error">
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default KOT;
